// Bont Size Charts JavaScript (Enhanced with Width Calculation)
// Automatically loads correct calculator based on metafield handle
// Professional Australian English commenting standards
(function () {
  'use strict';

  console.log("Bont Size Calculator loaded successfully");

  // --- Page Router ---
  document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM Content Loaded - Initialising calculator");

    // Skip initialisation on pages without the chart UI
    const hasChartUI =
      document.querySelector(".bont-size-chart-container, .size-chart-container") ||
      document.getElementById("left-foot-length") ||
      document.querySelector("input[name='left-foot-length']");
    if (!hasChartUI) {
      console.log("No size-chart UI on this page — skipping init");
      return;
    }

    // Get metafield handle from various possible sources
    const metafieldHandle = getMetafieldHandle();

    if (!metafieldHandle) {
      console.warn("No metafield handle found for Bont size chart");
      return;
    }

    console.log("Detected metafield handle:", metafieldHandle);

    // Route to appropriate calculator based on metafield handle
    switch (metafieldHandle) {
      case "bont-size-chart-slipstream-and-vaypor-boots":
      case "slipstream-vaypor":
        initSlipstreamVaypor();
        break;
      case "bont-size-chart-eclipse-boot":
      case "eclipse":
        initEclipse();
        break;
      case "bont-size-chart-parkstar-prostar":
      case "parkstar-prostar":
        initParkstarProstar();
        break;
      case "bont-size-chart-all-other-inline-and-roller-skate-boots":
      case "general-inline-roller":
        initGeneralInlineRoller();
        break;
      default:
        console.warn(`Unknown metafield handle: ${metafieldHandle}`);
    }
  });

  // --- Metafield Handle Detection ---
  function getMetafieldHandle() {
    // Try multiple methods to get the metafield handle

    // Method 1: Check for data attribute on body or main container
    const bodyHandle = document.body.getAttribute("data-bont-chart-handle");
    if (bodyHandle) return bodyHandle;

    // Method 2: Check for data attribute on chart container
    const chartContainer = document.querySelector(".bont-size-chart-container, .size-chart-container");
    if (chartContainer) {
      const containerHandle =
        chartContainer.getAttribute("data-chart-handle") ||
        chartContainer.getAttribute("data-metafield-handle");
      if (containerHandle) return containerHandle;
    }

    // Method 3: Check for global variable
    if (typeof window.bontChartHandle !== "undefined") {
      return window.bontChartHandle;
    }

    // Method 4: Check for Shopify metafield in meta tags
    const metaTag = document.querySelector('meta[name="bont-chart-handle"]');
    if (metaTag) return metaTag.getAttribute("content");

    // Method 5: Fallback to URL pathname (legacy support)
    const url = window.location.pathname;
    if (url.includes("slipstream") || url.includes("vaypor")) {
      return "slipstream-vaypor";
    } else if (url.includes("eclipse")) {
      return "eclipse";
    } else if (url.includes("parkstar") || url.includes("prostar")) {
      return "parkstar-prostar";
    } else if (url.includes("inline") || url.includes("roller")) {
      return "general-inline-roller";
    }

    return "slipstream-vaypor"; // Default fallback for enhanced width functionality
  }

  // --- Shared Handlers ---
  function setupHandlers(calculatorFunction) {
    console.log("Setting up event handlers");

    // Define a stable root to scope all listeners (prefer the chart container)
    const root =
      document.querySelector(".bont-size-chart-container") ||
      document.querySelector(".size-chart-container") ||
      document; // last-resort

    // Acceptable Calculate button selectors (extendable)
    const CALC_SELECTORS = [
      "#calculate-size-btn",
      ".goButton a",
      ".goButton .btn",
      ".go-button",
      ".calculate-button",
      "[data-role='bont-calc']",
      "button[type='submit'].calculate",
      "button[name='calculate']",
      "button[onclick*='calculate']"
    ];
    const CALC_QUERY = CALC_SELECTORS.join(",");

    // 1) Event delegation => works for late-injected buttons
    root.addEventListener("click", function (event) {
      const btn = event.target.closest(CALC_QUERY);
      if (!btn) return;
      event.preventDefault();
      console.log("Calculate button (delegated) clicked");
      calculatorFunction();
    }, true);

    // 2) Try to find one immediately for early feedback
    const immediateBtn = root.querySelector(CALC_QUERY);
    if (immediateBtn) {
      console.log("Found calculate button (immediate)", immediateBtn);
    } else {
      console.warn("Calculate button not found (yet) — observing for injection");
      // 3) Observe root for late injection of the button
      const mo = new MutationObserver((muts, obs) => {
        const found = root.querySelector(CALC_QUERY);
        if (found) {
          console.log("Found calculate button (observed)", found);
          obs.disconnect();
        }
      });
      mo.observe(root, { subtree: true, childList: true });
    }

    // 4) Enter key on inputs (keydown is more reliable for number inputs)
    const wireInputs = () => {
      root.querySelectorAll(".form-text, .foot-length-input, .foot-width-input, input[type='number']")
        .forEach(input => {
          if (input.__bontKeysBound) return; // Avoid double-binding
          input.__bontKeysBound = true;
          input.addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
              event.preventDefault();
              console.log("Enter key pressed, calculating");
              calculatorFunction();
            }
          });
        });
    };
    wireInputs();

    // Observe for inputs added later
    const io = new MutationObserver(() => wireInputs());
    io.observe(root, { subtree: true, childList: true });

    // 5) Table hover (scoped + safe rebind)
    const wireTableHover = () => {
      root.querySelectorAll(".bont-size-chart-table td").forEach(cell => {
        if (cell.__bontHoverBound) return;
        cell.__bontHoverBound = true;
        cell.addEventListener("mouseenter", function () { highlightTableCell(this); });
        cell.addEventListener("mouseleave", function () { clearTableHighlights(this); });
      });
    };
    wireTableHover();
    const to = new MutationObserver(() => wireTableHover());
    to.observe(root, { subtree: true, childList: true });
  }

  function highlightTableCell(cell) {
    const table = cell.closest("table");
    const columnIndex = cell.cellIndex;

    // Clear existing highlights
    table.querySelectorAll("td, th").forEach(element => {
      element.classList.remove("highlight-col", "highlight-row");
    });

    // Highlight column
    table.querySelectorAll("tr").forEach(row => {
      if (row.cells.length > columnIndex) {
        row.cells[columnIndex].classList.add("highlight-col");
      }
    });

    // Highlight row
    cell.parentElement.querySelectorAll("td").forEach(tableData => {
      tableData.classList.add("highlight-row");
    });
  }

  function clearTableHighlights(cell) {
    const table = cell.closest("table");
    table.querySelectorAll("td, th").forEach(element => {
      element.classList.remove("highlight-col", "highlight-row");
    });
  }

  // --- Chart 1: Slipstream & Vaypor (Enhanced with Width Calculation) ---
  function initSlipstreamVaypor() {
    console.log("Initialising Slipstream/Vaypor calculator with width functionality");
    setupHandlers(runSlipstreamVayporWithWidth);
  }

  function runSlipstreamVayporWithWidth() {
    console.log("Running Slipstream/Vaypor calculator with width");

    // Get length inputs
    const leftFootLengthInput = document.getElementById("left-foot-length") ||
      document.querySelector("input[name='left-foot-length']") ||
      document.querySelector(".form-text");
    const rightFootLengthInput = document.getElementById("right-foot-length") ||
      document.querySelector("input[name='right-foot-length']");

    // Get width inputs
    const leftFootWidthInput = document.getElementById("left-foot-width") ||
      document.querySelector("input[name='left-foot-width']");
    const rightFootWidthInput = document.getElementById("right-foot-width") ||
      document.querySelector("input[name='right-foot-width']");

    // Parse length measurements
    const leftFootLength = leftFootLengthInput && leftFootLengthInput.value ?
      parseFloat(leftFootLengthInput.value) : null;
    const rightFootLength = rightFootLengthInput && rightFootLengthInput.value ?
      parseFloat(rightFootLengthInput.value) : null;

    // Parse width measurements
    const leftFootWidth = leftFootWidthInput && leftFootWidthInput.value ?
      parseFloat(leftFootWidthInput.value) : null;
    const rightFootWidth = rightFootWidthInput && rightFootWidthInput.value ?
      parseFloat(rightFootWidthInput.value) : null;

    // Check if at least one foot has length data
    if (!leftFootLength && !rightFootLength) {
      alert("Please enter a valid length measurement for at least one foot");
      return;
    }

    // LEFT FOOT
    if (leftFootLength && !isNaN(leftFootLength)) {
      console.log("Calculating LEFT foot - Length:", leftFootLength, "Width:", leftFootWidth);
      const leftResult = getSlipstreamVayporSizeWithWidth(leftFootLength, leftFootWidth);
      console.log("Left result:", leftResult);

      updateResultDisplay(".left-bont", leftResult.bontSize);
      updateResultDisplay(".left-width", leftResult.widthCategory);
    } else {
      updateResultDisplay(".left-bont", "Enter measurements");
      updateResultDisplay(".left-width", "Not specified");
    }

    // RIGHT FOOT
    if (rightFootLength && !isNaN(rightFootLength)) {
      console.log("Calculating RIGHT foot - Length:", rightFootLength, "Width:", rightFootWidth);
      const rightResult = getSlipstreamVayporSizeWithWidth(rightFootLength, rightFootWidth);
      console.log("Right result:", rightResult);

      updateResultDisplay(".right-bont", rightResult.bontSize);
      updateResultDisplay(".right-width", rightResult.widthCategory);
    } else {
      updateResultDisplay(".right-bont", "Enter measurements");
      updateResultDisplay(".right-width", "Not specified");
    }
  }

  function getSlipstreamVayporSizeWithWidth(footLength, footWidth = null) {
    // Enhanced size chart with width ranges for Slipstream & Vaypor boots
    const sizeChart = [
      // Under 240mm logic with width ranges
      { minLength: 175, maxLength: 179, bontSize: "180", standardWidthMin: 65, standardWidthMax: 69, wideWidthMin: 69, wideWidthMax: 73 },
      { minLength: 180, maxLength: 184, bontSize: "185", standardWidthMin: 68, standardWidthMax: 72, wideWidthMin: 72, wideWidthMax: 76 },
      { minLength: 185, maxLength: 189, bontSize: "190", standardWidthMin: 69, standardWidthMax: 73, wideWidthMin: 73, wideWidthMax: 77 },
      { minLength: 190, maxLength: 194, bontSize: "195", standardWidthMin: 70, standardWidthMax: 74, wideWidthMin: 74, wideWidthMax: 78 },
      { minLength: 195, maxLength: 199, bontSize: "200", standardWidthMin: 71, standardWidthMax: 75, wideWidthMin: 75, wideWidthMax: 79 },
      { minLength: 200, maxLength: 204, bontSize: "205", standardWidthMin: 74, standardWidthMax: 78, wideWidthMin: 78, wideWidthMax: 82 },
      { minLength: 205, maxLength: 209, bontSize: "210", standardWidthMin: 76, standardWidthMax: 85, wideWidthMin: 80, wideWidthMax: 89 },
      { minLength: 210, maxLength: 213, bontSize: "215", standardWidthMin: 77, standardWidthMax: 86, wideWidthMin: 81, wideWidthMax: 90 },
      { minLength: 214, maxLength: 219, bontSize: "220", standardWidthMin: 79, standardWidthMax: 88, wideWidthMin: 83, wideWidthMax: 92 },
      { minLength: 220, maxLength: 223, bontSize: "225", standardWidthMin: 80, standardWidthMax: 89, wideWidthMin: 84, wideWidthMax: 93 },
      { minLength: 224, maxLength: 229, bontSize: "230", standardWidthMin: 82, standardWidthMax: 91, wideWidthMin: 86, wideWidthMax: 95 },
      { minLength: 230, maxLength: 234, bontSize: "235", standardWidthMin: 84, standardWidthMax: 94, wideWidthMin: 88, wideWidthMax: 98 },
      { minLength: 235, maxLength: 239, bontSize: "240", standardWidthMin: 85, standardWidthMax: 95, wideWidthMin: 89, wideWidthMax: 99 },

      // Above 240mm logic with width ranges
      { minLength: 240, maxLength: 244, bontSize: "245", standardWidthMin: 87, standardWidthMax: 96, wideWidthMin: 91, wideWidthMax: 100 },
      { minLength: 245, maxLength: 250, bontSize: "250", standardWidthMin: 88, standardWidthMax: 98, wideWidthMin: 92, wideWidthMax: 102 },
      { minLength: 251, maxLength: 254, bontSize: "255", standardWidthMin: 89, standardWidthMax: 99, wideWidthMin: 93, wideWidthMax: 103 },
      { minLength: 255, maxLength: 260, bontSize: "260", standardWidthMin: 90, standardWidthMax: 101, wideWidthMin: 94, wideWidthMax: 105 },
      { minLength: 261, maxLength: 264, bontSize: "265", standardWidthMin: 92, standardWidthMax: 102, wideWidthMin: 96, wideWidthMax: 106 },
      { minLength: 265, maxLength: 270, bontSize: "270", standardWidthMin: 93, standardWidthMax: 103, wideWidthMin: 97, wideWidthMax: 107 },
      { minLength: 271, maxLength: 274, bontSize: "275", standardWidthMin: 95, standardWidthMax: 105, wideWidthMin: 99, wideWidthMax: 109 },
      { minLength: 275, maxLength: 280, bontSize: "280", standardWidthMin: 97, standardWidthMax: 108, wideWidthMin: 101, wideWidthMax: 112 },
      { minLength: 281, maxLength: 284, bontSize: "285", standardWidthMin: 98, standardWidthMax: 109, wideWidthMin: 102, wideWidthMax: 113 },
      { minLength: 285, maxLength: 290, bontSize: "290", standardWidthMin: 99, standardWidthMax: 110, wideWidthMin: 103, wideWidthMax: 114 },
      { minLength: 291, maxLength: 294, bontSize: "295", standardWidthMin: 100, standardWidthMax: 112, wideWidthMin: 104, wideWidthMax: 116 },
      { minLength: 295, maxLength: 300, bontSize: "300", standardWidthMin: 102, standardWidthMax: 113, wideWidthMin: 106, wideWidthMax: 117 },
      { minLength: 301, maxLength: 304, bontSize: "305", standardWidthMin: 104, standardWidthMax: 116, wideWidthMin: 108, wideWidthMax: 118 },
      { minLength: 305, maxLength: 310, bontSize: "310", standardWidthMin: 105, standardWidthMax: 117, wideWidthMin: 109, wideWidthMax: 119 },
      { minLength: 311, maxLength: 314, bontSize: "315", standardWidthMin: 107, standardWidthMax: 119, wideWidthMin: 111, wideWidthMax: 123 }
    ];

    // Find the size range based on foot length
    let lengthBasedSize = sizeChart.find(range =>
      footLength >= range.minLength && footLength <= range.maxLength
    );

    if (!lengthBasedSize) {
      console.warn("No size match found for length:", footLength);
      return { bontSize: "N/A", widthCategory: "N/A" };
    }

    let finalSize = lengthBasedSize.bontSize;
    let widthCategory = "Not Specified";

    console.log(`Length ${footLength}mm matched to size ${lengthBasedSize.bontSize}`);

    // If width is provided, determine category based on the length-based size only
    if (footWidth !== null && !isNaN(footWidth)) {
      console.log(`Width ${footWidth}mm provided, checking fit in size ${finalSize}`);

      if (footWidth >= lengthBasedSize.standardWidthMin && footWidth <= lengthBasedSize.standardWidthMax) {
        widthCategory = "Standard";
        console.log(`Width ${footWidth}mm fits as Standard in size ${finalSize}`);
      } else if (footWidth >= lengthBasedSize.wideWidthMin && footWidth <= lengthBasedSize.wideWidthMax) {
        widthCategory = "Double Wide";
        console.log(`Width ${footWidth}mm fits as Double Wide in size ${finalSize}`);
      } else {
        // Width doesn't fit in either standard or wide range for this size
        widthCategory = "Custom";
        console.log(
          `Width ${footWidth}mm doesn't fit in size ${finalSize} ranges (Standard: ${lengthBasedSize.standardWidthMin}-${lengthBasedSize.standardWidthMax}mm, Wide: ${lengthBasedSize.wideWidthMin}-${lengthBasedSize.wideWidthMax}mm), categorising as Custom`
        );
      }
    }

    return {
      bontSize: finalSize,
      widthCategory: widthCategory
    };
  }

  // --- Chart 2: Eclipse (uses same logic as Slipstream & Vaypor) ---
  function initEclipse() {
    console.log("Initialising Eclipse calculator with width functionality");
    setupHandlers(runSlipstreamVayporWithWidth);
  }

  // --- Chart 3: Parkstar / Prostar (Enhanced with Width Calculation) ---
  function initParkstarProstar() {
    console.log("Initialising Parkstar/Prostar calculator with width functionality");
    setupHandlers(runParkstarProstarWithWidth);
  }

  function runParkstarProstarWithWidth() {
    console.log("Running Parkstar/Prostar calculator with width");

    // Get length inputs
    const leftFootLengthInput = document.getElementById("left-foot-length") ||
      document.querySelector("input[name='left-foot-length']") ||
      document.querySelector(".form-text");
    const rightFootLengthInput = document.getElementById("right-foot-length") ||
      document.querySelector("input[name='right-foot-length']");

    // Get width inputs
    const leftFootWidthInput = document.getElementById("left-foot-width") ||
      document.querySelector("input[name='left-foot-width']");
    const rightFootWidthInput = document.getElementById("right-foot-width") ||
      document.querySelector("input[name='right-foot-width']");

    // Parse length measurements
    const leftFootLength = leftFootLengthInput && leftFootLengthInput.value ?
      parseFloat(leftFootLengthInput.value) : null;
    const rightFootLength = rightFootLengthInput && rightFootLengthInput.value ?
      parseFloat(rightFootLengthInput.value) : null;

    // Parse width measurements
    const leftFootWidth = leftFootWidthInput && leftFootWidthInput.value ?
      parseFloat(leftFootWidthInput.value) : null;
    const rightFootWidth = rightFootWidthInput && rightFootWidthInput.value ?
      parseFloat(rightFootWidthInput.value) : null;

    // Check if at least one foot has length data
    if (!leftFootLength && !rightFootLength) {
      alert("Please enter a valid length measurement for at least one foot");
      return;
    }

    // LEFT FOOT
    if (leftFootLength && !isNaN(leftFootLength)) {
      console.log("Calculating LEFT foot - Length:", leftFootLength, "Width:", leftFootWidth);
      const leftResult = getParkstarProstarSizeWithWidth(leftFootLength, leftFootWidth);
      console.log("Left result:", leftResult);

      updateResultDisplay(".left-bont", leftResult.bontSize);
      updateResultDisplay(".left-euro", leftResult.euroSize);
      updateResultDisplay(".left-width", leftResult.widthCategory);
    } else {
      updateResultDisplay(".left-bont", "Enter measurements");
      updateResultDisplay(".left-euro", "Enter measurements");
      updateResultDisplay(".left-width", "Not specified");
    }

    // RIGHT FOOT
    if (rightFootLength && !isNaN(rightFootLength)) {
      console.log("Calculating RIGHT foot - Length:", rightFootLength, "Width:", rightFootWidth);
      const rightResult = getParkstarProstarSizeWithWidth(rightFootLength, rightFootWidth);
      console.log("Right result:", rightResult);

      updateResultDisplay(".right-bont", rightResult.bontSize);
      updateResultDisplay(".right-euro", rightResult.euroSize);
      updateResultDisplay(".right-width", rightResult.widthCategory);
    } else {
      updateResultDisplay(".right-bont", "Enter measurements");
      updateResultDisplay(".right-euro", "Enter measurements");
      updateResultDisplay(".right-width", "Not specified");
    }
  }

  function getParkstarProstarSizeWithWidth(footLength, footWidth = null) {
    // Enhanced size chart with width ranges for Parkstar/Prostar boots
    const sizeChart = [
      // Sizes without width data (children's sizes mostly)
      { minLength: 174, maxLength: 182, bontSize: "10C", euroSize: "28" },
      { minLength: 183, maxLength: 190, bontSize: "11C", euroSize: "29" },
      { minLength: 191, maxLength: 198, bontSize: "12C", euroSize: "30" },
      { minLength: 199, maxLength: 202, bontSize: "13C", euroSize: "31" },
      { minLength: 203, maxLength: 206, bontSize: "13.5C", euroSize: "32" },
      { minLength: 207, maxLength: 216, bontSize: "1", euroSize: "33" },
      { minLength: 217, maxLength: 218, bontSize: "2", euroSize: "34" },
      { minLength: 219, maxLength: 223, bontSize: "2.5", euroSize: "34.5" },

      // Sizes with width data (adult sizes)
      { minLength: 224, maxLength: 228, bontSize: "3",   euroSize: "35",   narrowMin: 79, narrowMax: 83, standardMin: 84, standardMax: 93, wideMin: 94, wideMax: 98, doubleWideMin: 99,  doubleWideMax: 103 },
      { minLength: 229, maxLength: 231, bontSize: "3.5", euroSize: "35.5", narrowMin: 80, narrowMax: 84, standardMin: 85, standardMax: 94, wideMin: 95, wideMax: 99, doubleWideMin: 100, doubleWideMax: 104 },
      { minLength: 232, maxLength: 237, bontSize: "4",   euroSize: "36",   narrowMin: 82, narrowMax: 86, standardMin: 86, standardMax: 96, wideMin: 97, wideMax: 101, doubleWideMin: 102, doubleWideMax: 106 },
      { minLength: 238, maxLength: 241, bontSize: "4.5", euroSize: "36.5", narrowMin: 82, narrowMax: 86, standardMin: 87, standardMax: 97, wideMin: 98, wideMax: 102, doubleWideMin: 103, doubleWideMax: 107 },
      { minLength: 242, maxLength: 245, bontSize: "5",   euroSize: "37",   narrowMin: 84, narrowMax: 88, standardMin: 89, standardMax: 98, wideMin: 99, wideMax: 103, doubleWideMin: 104, doubleWideMax: 108 },
      { minLength: 246, maxLength: 250, bontSize: "5.5", euroSize: "37.5", narrowMin: 85, narrowMax: 89, standardMin: 90, standardMax: 100, wideMin: 101, wideMax: 105, doubleWideMin: 106, doubleWideMax: 110 },
      { minLength: 251, maxLength: 253, bontSize: "6",   euroSize: "38",   narrowMin: 86, narrowMax: 90, standardMin: 91, standardMax: 101, wideMin: 102, wideMax: 106, doubleWideMin: 107, doubleWideMax: 111 },
      { minLength: 254, maxLength: 259, bontSize: "6.5", euroSize: "38.5", narrowMin: 87, narrowMax: 91, standardMin: 92, standardMax: 103, wideMin: 104, wideMax: 108, doubleWideMin: 109, doubleWideMax: 113 },
      { minLength: 260, maxLength: 262, bontSize: "7",   euroSize: "39",   narrowMin: 89, narrowMax: 93, standardMin: 94, standardMax: 104, wideMin: 105, wideMax: 109, doubleWideMin: 110, doubleWideMax: 114 },
      { minLength: 263, maxLength: 268, bontSize: "7.5", euroSize: "40",   narrowMin: 90, narrowMax: 94, standardMin: 95, standardMax: 105, wideMin: 106, wideMax: 110, doubleWideMin: 111, doubleWideMax: 115 },
      { minLength: 269, maxLength: 272, bontSize: "8",   euroSize: "41",   narrowMin: 91, narrowMax: 95, standardMin: 96, standardMax: 107, wideMin: 108, wideMax: 112, doubleWideMin: 113, doubleWideMax: 117 },
      { minLength: 273, maxLength: 277, bontSize: "8.5", euroSize: "41.5", narrowMin: 92, narrowMax: 96, standardMin: 97, standardMax: 108, wideMin: 109, wideMax: 113, doubleWideMin: 114, doubleWideMax: 118 },
      { minLength: 278, maxLength: 281, bontSize: "9",   euroSize: "42",   narrowMin: 94, narrowMax: 98, standardMin: 99, standardMax: 110, wideMin: 111, wideMax: 115, doubleWideMin: 116, doubleWideMax: 120 },
      { minLength: 282, maxLength: 286, bontSize: "9.5", euroSize: "43",   narrowMin: 95, narrowMax: 99, standardMin: 100, standardMax: 111, wideMin: 112, wideMax: 116, doubleWideMin: 117, doubleWideMax: 121 },
      { minLength: 287, maxLength: 290, bontSize: "10",  euroSize: "44",   narrowMin: 96, narrowMax: 100, standardMin: 101, standardMax: 112, wideMin: 113, wideMax: 117, doubleWideMin: 118, doubleWideMax: 122 },
      { minLength: 291, maxLength: 295, bontSize: "10.5", euroSize: "45",  narrowMin: 97, narrowMax: 101, standardMin: 102, standardMax: 114, wideMin: 115, wideMax: 119, doubleWideMin: 120, doubleWideMax: 124 },
      { minLength: 296, maxLength: 298, bontSize: "11",  euroSize: "46",   narrowMin: 99, narrowMax: 103, standardMin: 104, standardMax: 115, wideMin: 116, wideMax: 120, doubleWideMin: 121, doubleWideMax: 125 },
      { minLength: 299, maxLength: 302, bontSize: "11.5", euroSize: "47",  narrowMin: 100, narrowMax: 104, standardMin: 105, standardMax: 117, wideMin: 118, wideMax: 122, doubleWideMin: 123, doubleWideMax: 127 },
      { minLength: 303, maxLength: 304, bontSize: "12",  euroSize: "48",   narrowMin: 101, narrowMax: 105, standardMin: 106, standardMax: 118, wideMin: 119, wideMax: 123, doubleWideMin: 124, doubleWideMax: 128 },
      { minLength: 305, maxLength: 311, bontSize: "12.5", euroSize: "49",  narrowMin: 102, narrowMax: 106, standardMin: 107, standardMax: 119, wideMin: 120, wideMax: 124, doubleWideMin: 125, doubleWideMax: 129 },
      { minLength: 312, maxLength: 313, bontSize: "13",  euroSize: "50",   narrowMin: 104, narrowMax: 108, standardMin: 109, standardMax: 121, wideMin: 122, wideMax: 126, doubleWideMin: 127, doubleWideMax: 131 }
    ];

    // Find the size range based on foot length
    let lengthBasedSize = sizeChart.find(range =>
      footLength >= range.minLength && footLength <= range.maxLength
    );

    if (!lengthBasedSize) {
      console.warn("No size match found for length:", footLength);
      return { bontSize: "N/A", euroSize: "N/A", widthCategory: "N/A" };
    }

    let finalBontSize = lengthBasedSize.bontSize;
    let finalEuroSize = lengthBasedSize.euroSize;
    let widthCategory = "Not Specified";

    console.log(`Length ${footLength}mm matched to Bont size ${lengthBasedSize.bontSize}, Euro size ${lengthBasedSize.euroSize}`);

    // If width is provided and this size has width data, determine category
    if (footWidth !== null && !isNaN(footWidth) && lengthBasedSize.narrowMin !== undefined) {
      console.log(`Width ${footWidth}mm provided, checking fit in size ${finalBontSize}`);

      if (footWidth >= lengthBasedSize.narrowMin && footWidth <= lengthBasedSize.narrowMax) {
        widthCategory = "Narrow";
        console.log(`Width ${footWidth}mm fits as Narrow in size ${finalBontSize}`);
      } else if (footWidth >= lengthBasedSize.standardMin && footWidth <= lengthBasedSize.standardMax) {
        widthCategory = "Standard";
        console.log(`Width ${footWidth}mm fits as Standard in size ${finalBontSize}`);
      } else if (footWidth >= lengthBasedSize.wideMin && footWidth <= lengthBasedSize.wideMax) {
        widthCategory = "Wide";
        console.log(`Width ${footWidth}mm fits as Wide in size ${finalBontSize}`);
      } else if (footWidth >= lengthBasedSize.doubleWideMin && footWidth <= lengthBasedSize.doubleWideMax) {
        widthCategory = "Double Wide";
        console.log(`Width ${footWidth}mm fits as Double Wide in size ${finalBontSize}`);
      } else {
        widthCategory = "Custom";
        console.log(`Width ${footWidth}mm doesn't fit in size ${finalBontSize} ranges, categorising as Custom`);
      }
    } else if (footWidth !== null && !isNaN(footWidth) && lengthBasedSize.narrowMin === undefined) {
      // Size doesn't have width data (children's sizes)
      widthCategory = "Not Available";
      console.log(`Width data not available for size ${finalBontSize} (children's size)`);
    }

    return {
      bontSize: finalBontSize,
      euroSize: finalEuroSize,
      widthCategory: widthCategory
    };
  }

  // --- Chart 4: All Other Inline & Roller Boots (Enhanced with Width Calculation) ---
  function initGeneralInlineRoller() {
    console.log("Initialising General Inline/Roller calculator with width functionality");
    setupHandlers(runGeneralInlineRollerWithWidth);
  }

  function runGeneralInlineRollerWithWidth() {
    console.log("Running General Inline/Roller calculator with width");

    // Get length inputs
    const leftFootLengthInput = document.getElementById("left-foot-length") ||
      document.querySelector("input[name='left-foot-length']") ||
      document.querySelector(".form-text");
    const rightFootLengthInput = document.getElementById("right-foot-length") ||
      document.querySelector("input[name='right-foot-length']");

    // Get width inputs
    const leftFootWidthInput = document.getElementById("left-foot-width") ||
      document.querySelector("input[name='left-foot-width']");
    const rightFootWidthInput = document.getElementById("right-foot-width") ||
      document.querySelector("input[name='right-foot-width']");

    // Parse length measurements
    const leftFootLength = leftFootLengthInput && leftFootLengthInput.value ?
      parseFloat(leftFootLengthInput.value) : null;
    const rightFootLength = rightFootLengthInput && rightFootLengthInput.value ?
      parseFloat(rightFootLengthInput.value) : null;

    // Parse width measurements
    const leftFootWidth = leftFootWidthInput && leftFootWidthInput.value ?
      parseFloat(leftFootWidthInput.value) : null;
    const rightFootWidth = rightFootWidthInput && rightFootWidthInput.value ?
      parseFloat(rightFootWidthInput.value) : null;

    // Check if at least one foot has length data
    if (!leftFootLength && !rightFootLength) {
      alert("Please enter a valid length measurement for at least one foot");
      return;
    }

    // LEFT FOOT
    if (leftFootLength && !isNaN(leftFootLength)) {
      console.log("Calculating LEFT foot - Length:", leftFootLength, "Width:", leftFootWidth);
      const leftResult = getGeneralInlineRollerSizeWithWidth(leftFootLength, leftFootWidth);
      console.log("Left result:", leftResult);

      updateResultDisplay(".left-bont", leftResult.bontSize);
      updateResultDisplay(".left-euro", leftResult.euroSize);
      updateResultDisplay(".left-width", leftResult.widthCategory);
    } else {
      updateResultDisplay(".left-bont", "Enter measurements");
      updateResultDisplay(".left-euro", "Enter measurements");
      updateResultDisplay(".left-width", "Not specified");
    }

    // RIGHT FOOT
    if (rightFootLength && !isNaN(rightFootLength)) {
      console.log("Calculating RIGHT foot - Length:", rightFootLength, "Width:", rightFootWidth);
      const rightResult = getGeneralInlineRollerSizeWithWidth(rightFootLength, rightFootWidth);
      console.log("Right result:", rightResult);

      updateResultDisplay(".right-bont", rightResult.bontSize);
      updateResultDisplay(".right-euro", rightResult.euroSize);
      updateResultDisplay(".right-width", rightResult.widthCategory);
    } else {
      updateResultDisplay(".right-bont", "Enter measurements");
      updateResultDisplay(".right-euro", "Enter measurements");
      updateResultDisplay(".right-width", "Not specified");
    }
  }

  function getGeneralInlineRollerSizeWithWidth(footLength, footWidth = null) {
    // Enhanced size chart with width ranges for General Inline & Roller boots
    const sizeChart = [
      // Note: Some entries have special values like "75 and under" or "69 and under"
      // "-" entries mean that width category is not available for that size
      { minLength: 150, maxLength: 162, bontSize: "9 C",  euroSize: "27",  standardMin: 0,   standardMax: 75,  wideMin: 76,  wideMax: 80 },
      { minLength: 163, maxLength: 171, bontSize: "10 C", euroSize: "28",  standardMin: 70,  standardMax: 78,  wideMin: 79,  wideMax: 83,  narrowMin: 0,   narrowMax: 69 },
      { minLength: 172, maxLength: 179, bontSize: "11 C", euroSize: "29",  standardMin: 72,  standardMax: 80,  wideMin: 81,  wideMax: 85,  narrowMin: 68,  narrowMax: 71 },
      { minLength: 180, maxLength: 188, bontSize: "12 C", euroSize: "30",  standardMin: 74,  standardMax: 82,  wideMin: 83,  wideMax: 87,  narrowMin: 69,  narrowMax: 73 },
      { minLength: 189, maxLength: 198, bontSize: "13 C", euroSize: "31",  standardMin: 75,  standardMax: 84,  wideMin: 85,  wideMax: 89,  narrowMin: 70,  narrowMax: 74 },
      { minLength: 199, maxLength: 203, bontSize: "13.5 C", euroSize: "32", standardMin: 77, standardMax: 86,  wideMin: 87,  wideMax: 91,  narrowMin: 72,  narrowMax: 76 },
      { minLength: 204, maxLength: 207, bontSize: "1",    euroSize: "33",  standardMin: 78,  standardMax: 87,  wideMin: 88,  wideMax: 92,  doubleWideMin: 93,  doubleWideMax: 97,  narrowMin: 73,  narrowMax: 77 },
      { minLength: 208, maxLength: 215, bontSize: "2",    euroSize: "34",  standardMin: 81,  standardMax: 90,  wideMin: 91,  wideMax: 95,  doubleWideMin: 96,  doubleWideMax: 100, narrowMin: 76,  narrowMax: 80 },
      { minLength: 216, maxLength: 219, bontSize: "2.5",  euroSize: "34.5",standardMin: 82,  standardMax: 91,  wideMin: 92,  wideMax: 96,  doubleWideMin: 97,  doubleWideMax: 101, narrowMin: 77,  narrowMax: 81 },
      { minLength: 220, maxLength: 224, bontSize: "3",    euroSize: "35",  standardMin: 84,  standardMax: 93,  wideMin: 94,  wideMax: 98,  doubleWideMin: 99,  doubleWideMax: 103, narrowMin: 79,  narrowMax: 83 },
      { minLength: 225, maxLength: 228, bontSize: "3.5",  euroSize: "35.5",standardMin: 85,  standardMax: 94,  wideMin: 95,  wideMax: 99,  doubleWideMin: 100, doubleWideMax: 104, narrowMin: 80,  narrowMax: 84 },
      { minLength: 229, maxLength: 232, bontSize: "4",    euroSize: "36",  standardMin: 86,  standardMax: 96,  wideMin: 97,  wideMax: 101, doubleWideMin: 102, doubleWideMax: 106, narrowMin: 82,  narrowMax: 86 },
      { minLength: 233, maxLength: 237, bontSize: "4.5",  euroSize: "36.5",standardMin: 87,  standardMax: 97,  wideMin: 98,  wideMax: 102, doubleWideMin: 103, doubleWideMax: 107, narrowMin: 82,  narrowMax: 86 },
      { minLength: 238, maxLength: 241, bontSize: "5",    euroSize: "37",  standardMin: 89,  standardMax: 98,  wideMin: 99,  wideMax: 103, doubleWideMin: 104, doubleWideMax: 108, narrowMin: 84,  narrowMax: 88 },
      { minLength: 242, maxLength: 246, bontSize: "5.5",  euroSize: "37.5",standardMin: 90,  standardMax: 100, wideMin: 101, wideMax: 105, doubleWideMin: 106, doubleWideMax: 110, narrowMin: 85,  narrowMax: 89 },
      { minLength: 247, maxLength: 250, bontSize: "6",    euroSize: "38",  standardMin: 91,  standardMax: 101, wideMin: 102, wideMax: 106, doubleWideMin: 107, doubleWideMax: 111, narrowMin: 86,  narrowMax: 90 },
      { minLength: 251, maxLength: 255, bontSize: "6.5",  euroSize: "38.5",standardMin: 92,  standardMax: 103, wideMin: 104, wideMax: 108, doubleWideMin: 109, doubleWideMax: 113, narrowMin: 87,  narrowMax: 91 },
      { minLength: 256, maxLength: 259, bontSize: "7",    euroSize: "39",  standardMin: 94,  standardMax: 104, wideMin: 105, wideMax: 109, doubleWideMin: 110, doubleWideMax: 114, narrowMin: 89,  narrowMax: 93 },
      { minLength: 260, maxLength: 264, bontSize: "7.5",  euroSize: "40",  standardMin: 95,  standardMax: 105, wideMin: 106, wideMax: 110, doubleWideMin: 111, doubleWideMax: 115, narrowMin: 90,  narrowMax: 94 },
      { minLength: 265, maxLength: 268, bontSize: "8",    euroSize: "41",  standardMin: 96,  standardMax: 107, wideMin: 108, wideMax: 112, doubleWideMin: 113, doubleWideMax: 117, narrowMin: 91,  narrowMax: 95 },
      { minLength: 269, maxLength: 272, bontSize: "8.5",  euroSize: "41.5",standardMin: 97,  standardMax: 108, wideMin: 109, wideMax: 113, doubleWideMin: 114, doubleWideMax: 118, narrowMin: 92,  narrowMax: 96 },
      { minLength: 273, maxLength: 277, bontSize: "9",    euroSize: "42",  standardMin: 99,  standardMax: 110, wideMin: 111, wideMax: 115, doubleWideMin: 116, doubleWideMax: 120, narrowMin: 94,  narrowMax: 98 },
      { minLength: 278, maxLength: 281, bontSize: "9.5",  euroSize: "43",  standardMin: 100, standardMax: 111, wideMin: 112, wideMax: 116, doubleWideMin: 117, doubleWideMax: 121, narrowMin: 95,  narrowMax: 99 },
      { minLength: 282, maxLength: 286, bontSize: "10",   euroSize: "44",  standardMin: 101, standardMax: 112, wideMin: 113, wideMax: 117, doubleWideMin: 118, doubleWideMax: 122, narrowMin: 96,  narrowMax: 100 },
      { minLength: 287, maxLength: 290, bontSize: "10.5", euroSize: "45",  standardMin: 102, standardMax: 114, wideMin: 115, wideMax: 119, doubleWideMin: 120, doubleWideMax: 124, narrowMin: 97,  narrowMax: 101 },
      { minLength: 291, maxLength: 295, bontSize: "11",   euroSize: "46",  standardMin: 104, standardMax: 115, wideMin: 116, wideMax: 120, doubleWideMin: 121, doubleWideMax: 125, narrowMin: 99,  narrowMax: 103 },
      { minLength: 296, maxLength: 299, bontSize: "11.5", euroSize: "47",  standardMin: 105, standardMax: 117, wideMin: 118, wideMax: 122, doubleWideMin: 123, doubleWideMax: 127, narrowMin: 100, narrowMax: 104 },
      { minLength: 300, maxLength: 304, bontSize: "12",   euroSize: "48",  standardMin: 106, standardMax: 118, wideMin: 119, wideMax: 123, doubleWideMin: 124, doubleWideMax: 128, narrowMin: 101, narrowMax: 105 },
      { minLength: 305, maxLength: 308, bontSize: "12.5", euroSize: "49",  standardMin: 107, standardMax: 119, wideMin: 120, wideMax: 124, doubleWideMin: 125, doubleWideMax: 129, narrowMin: 102, narrowMax: 106 },
      { minLength: 309, maxLength: 313, bontSize: "13",   euroSize: "50",  standardMin: 109, standardMax: 121, wideMin: 122, wideMax: 126, doubleWideMin: 127, doubleWideMax: 131, narrowMin: 104, narrowMax: 108 },
      { minLength: 314, maxLength: 317, bontSize: "13.5", euroSize: "51",  standardMin: 110, standardMax: 122, wideMin: 123, wideMax: 127, doubleWideMin: 128, doubleWideMax: 132, narrowMin: 105, narrowMax: 109 }
    ];

    // Find the size range based on foot length
    let lengthBasedSize = sizeChart.find(range =>
      footLength >= range.minLength && footLength <= range.maxLength
    );

    if (!lengthBasedSize) {
      console.warn("No size match found for length:", footLength);
      return { bontSize: "N/A", euroSize: "N/A", widthCategory: "N/A" };
    }

    let finalBontSize = lengthBasedSize.bontSize;
    let finalEuroSize = lengthBasedSize.euroSize;
    let widthCategory = "Not Specified";

    console.log(`Length ${footLength}mm matched to Bont size ${lengthBasedSize.bontSize}, Euro size ${lengthBasedSize.euroSize}`);

    // If width is provided, determine category based on available width ranges
    if (footWidth !== null && !isNaN(footWidth)) {
      console.log(`Width ${footWidth}mm provided, checking fit in size ${finalBontSize}`);

      if (lengthBasedSize.narrowMin !== undefined && footWidth >= lengthBasedSize.narrowMin && footWidth <= lengthBasedSize.narrowMax) {
        widthCategory = "Narrow";
        console.log(`Width ${footWidth}mm fits as Narrow in size ${finalBontSize}`);
      } else if (lengthBasedSize.standardMin !== undefined && footWidth >= lengthBasedSize.standardMin && footWidth <= lengthBasedSize.standardMax) {
        widthCategory = "Standard";
        console.log(`Width ${footWidth}mm fits as Standard in size ${finalBontSize}`);
      } else if (lengthBasedSize.wideMin !== undefined && footWidth >= lengthBasedSize.wideMin && footWidth <= lengthBasedSize.wideMax) {
        widthCategory = "Wide";
        console.log(`Width ${footWidth}mm fits as Wide in size ${finalBontSize}`);
      } else if (lengthBasedSize.doubleWideMin !== undefined && footWidth >= lengthBasedSize.doubleWideMin && footWidth <= lengthBasedSize.doubleWideMax) {
        widthCategory = "Double Wide";
        console.log(`Width ${footWidth}mm fits as Double Wide in size ${finalBontSize}`);
      } else {
        widthCategory = "Custom";
        console.log(`Width ${footWidth}mm doesn't fit in available size ${finalBontSize} ranges, categorising as Custom`);
      }
    }

    return {
      bontSize: finalBontSize,
      euroSize: finalEuroSize,
      widthCategory: widthCategory
    };
  }

  // --- Utility Functions ---
  function debugAvailableElements() {
    console.log("Available elements for debugging:");
    console.log("Elements with 'left':", document.querySelectorAll('[class*="left"]'));
    console.log("Elements with 'bont':", document.querySelectorAll('[class*="bont"]'));
    console.log("Elements with 'foot-size':", document.querySelectorAll('.foot-size'));
    console.log("Elements with 'value':", document.querySelectorAll('.value'));
    console.log("All span elements:", document.querySelectorAll('span'));
  }

  function updateResultDisplay(selector, value) {
    console.log(`Updating ${selector} with value: ${value}`);

    // Debug available elements first time
    if (!window.debuggedElements) {
      debugAvailableElements();
      window.debuggedElements = true;
    }

    // Try multiple possible selectors
    let element = document.querySelector(selector);

    // If not found, try within .value.foot-size containers
    if (!element) {
      element = document.querySelector(`.value.foot-size ${selector}`);
      console.log(`Trying within .value.foot-size: ${element ? 'found' : 'not found'}`);
    }

    // If not found, try within .foot-size containers
    if (!element) {
      element = document.querySelector(`.foot-size ${selector}`);
      console.log(`Trying within .foot-size: ${element ? 'found' : 'not found'}`);
    }

    // If still not found, try different variations
    if (!element) {
      const selectorWithoutDot = selector.replace('.', '');
      element = document.querySelector(`.${selectorWithoutDot}`) ||
        document.querySelector(`[class*="${selectorWithoutDot}"]`) ||
        document.querySelector(`#${selectorWithoutDot}`);
      console.log(`Trying variations: ${element ? 'found' : 'not found'}`);
    }

    if (element) {
      element.textContent = value;
      element.style.display = 'inline'; // Ensure it's visible
      console.log(`Successfully updated ${selector} with: ${value}`);
    } else {
      console.warn(`Result display element not found: ${selector}`);
      // Try to find any element that might be the result container
      const resultContainer = document.querySelector('.foot-size, .result, .size-result, .value');
      if (resultContainer) {
        console.log('Found result container, updating innerHTML');
        resultContainer.innerHTML = value;
      } else {
        console.log('No result container found at all');
      }
    }
  }

  // --- Global Error Handling (scoped to our file only) ---
  window.addEventListener("error", function (event) {
    try {
      const src = event?.filename || "";
      if (src && !src.includes("custom.js")) return; // ignore other files' errors under our label
    } catch (_) { /* ignore */ }
    console.error("Bont Size Chart Error:", event.error || event.message);
  }, true);

  // Test function for debugging
  function testCalculator() {
    console.log("Testing calculator with sample values");
    const metafieldHandle = getMetafieldHandle();

    if (metafieldHandle === "parkstar-prostar") {
      document.getElementById('left-foot-length').value = '245';
      document.getElementById('left-foot-width').value = '95';
      runParkstarProstarWithWidth();
    } else if (metafieldHandle === "general-inline-roller") {
      document.getElementById('left-foot-length').value = '245';
      document.getElementById('left-foot-width').value = '95';
      runGeneralInlineRollerWithWidth();
    } else {
      document.getElementById('left-foot-length').value = '245';
      document.getElementById('left-foot-width').value = '95';
      runSlipstreamVayporWithWidth();
    }
  }

  // Test function specifically for Parkstar/Prostar
  function testParkstarProstar() {
    console.log("Testing Parkstar/Prostar calculator with sample values");
    document.getElementById('left-foot-length').value = '245';
    document.getElementById('left-foot-width').value = '95';
    runParkstarProstarWithWidth();
  }

  // Test function specifically for General Inline Roller
  function testGeneralInlineRoller() {
    console.log("Testing General Inline/Roller calculator with sample values");
    document.getElementById('left-foot-length').value = '245';
    document.getElementById('left-foot-width').value = '95';
    runGeneralInlineRollerWithWidth();
  }

  // Make test functions available globally for debugging
  window.testCalculator = testCalculator;
  window.testParkstarProstar = testParkstarProstar;
  window.testGeneralInlineRoller = testGeneralInlineRoller;

  // Export functions for testing (if needed)
  if (typeof module !== "undefined" && module.exports) {
    module.exports = {
      getSlipstreamVayporSizeWithWidth,
      getParkstarProstarSizeWithWidth,
      getGeneralInlineRollerSizeWithWidth,
      getMetafieldHandle
    };
  }

  console.log("Bont Size Calculator script loaded completely");
})();
